import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { getDevData } from "../../services/generalService";
import { BorrowerDetailsObj } from "../../utils/types";

const initialState: BorrowerDetailsObj = {
  data: null,
  isLoading: true,
  isSuccess: false,
  isError: false,
  isUserValidated:false
};

export const getBorrowersData = createAsyncThunk(
  "loans/getBorrowerDetails",
  async (url: string, thunkAPI) => {
    try {
      const data = await getDevData(url);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

const borrowerDetailsSlice = createSlice({
  name: "borrower",
  initialState,
  reducers: {
    setUserValidation: (state, action) => {
      state.isUserValidated = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBorrowersData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getBorrowersData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload[0];
      })
      .addCase(getBorrowersData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
      });
  },
});

export default borrowerDetailsSlice.reducer;
export const borrowerDetailsAction = borrowerDetailsSlice.actions;
